import { cnpj as cnpjValidacao, cpf } from 'cpf-cnpj-validator';
import { useEffect, useState } from 'react';
import InputMask from 'react-input-mask';
import { isFictor } from '../../shared/constantes/perfilFictor';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import Spinner from '../../shared/spinner';
import { Cliente } from '../../shared/model/Cliente';
import { format, parseISO, set } from 'date-fns';
import { ClienteDTO } from '../../shared/dto/clienteDTO';
import { ClienteEndereco } from '../../shared/model/clienteEndereco';
import { AcaoPropostaEnum } from '../../shared/constantes/acaoPropostaEnum';
import ReprovarOuPendenciarPropostaModal from '../../shared/reprovarOuPendenciarPropostaModal';
import ClienteService from '../../services/clienteService';
import ViaCepService from '../../services/viaCepService';
import CustomAlert from '../../shared/customAlert';
import { EstadosCivis } from '../../shared/constantes/estadosCivis';
import { TiposResidencia } from '../../shared/constantes/tiposResidencia';
import { TiposContaBanco } from '../../shared/constantes/tiposContaBanco';
import { NaturezaOcupacoes } from '../../shared/constantes/naturezasOcupacoes';
import { EstadosBrasil } from '../../shared/constantes/estadosBrasil';
import { situacaoPepEnum } from '../../shared/constantes/situacaoPepEnum';
import { cpf as cpfValidacao } from 'cpf-cnpj-validator';
import { useVerificaPermissao } from '../../shared/useVerificaPermissao';
import PropostaService from '../../services/propostaService';
import PropostaEsteiraService from '../../services/propostaEsteiraService';
import { PropostaEsteira } from '../../shared/model/propostaEsteira';
import { id } from 'date-fns/locale';
import BancoService from '../../services/bancoService';
import { Banco } from '../../shared/model/banco';
import { Role } from '../../shared/model/role';
import UsuarioService from '../../services/usuarioService';
import DateInput from '../../shared/dateInput';
import { parse } from 'path';



function ClienteComponent() {
  useVerificaPermissao();
  const location = useLocation();
  const navigate = useNavigate();
  const { idCliente, edicao, idProposta, atualizacaoCadastro } = location.state || {};
  const Idusuario = localStorage.getItem('id') ?? '';
  const propostaService = new PropostaService();


  const sexos = [
    { value: '', label: '' },
    { value: 'Masculino', label: 'Masculino' },
    { value: 'Feminino', label: 'Feminino' },
  ];

  const temposResidencia = [
    { value: '', label: '' },
    { value: '1', label: '1 ano' },
    { value: '2', label: '2 anos' },
    { value: '3', label: '3 anos' },
    { value: '4', label: '4 anos' },
    { value: '5', label: '5 anos' },
    { value: '6', label: '6 anos' },
    { value: '7', label: '7 anos' },
    { value: '8', label: '8 anos' },
    { value: '9', label: '9 anos' },
    { value: '10', label: '10 anos' },
    { value: '11', label: '11 anos' },
    { value: '12', label: '12 anos' },
    { value: '13', label: '13 anos' },
    { value: '14', label: '14 anos' },
    { value: '15', label: '15 anos' },
    { value: '+15', label: '+15 anos' },
  ];

  const estadosCivil = EstadosCivis;
  const tiposResidencia = TiposResidencia;
  const naturezaOcupacoes = NaturezaOcupacoes;
  const tiposConta = TiposContaBanco;
  const estadosBrasil = EstadosBrasil

  const [alert, setAlert] = useState<{ message: string, type: 'success' | 'warning' | 'error' } | null>(null);
  const sleep = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));

  const [cliente, setCliente] = useState<Cliente>(new Cliente());

  const [nome, setNome] = useState('');
  const [dtNascimento, setDtNascimento] = useState('');
  const [isPEP, setIsPEP] = useState(0);
  const [rg, setRg] = useState('');
  const [dtRg, setDtRg] = useState('');
  const [orgaoRg, setOrgaoRg] = useState('');
  const [ufRg, setUfRg] = useState('');
  const [nomeRepresentanteLegal, setNomeRepresentanteLegal] = useState('');
  const [cpfRepresentanteLegal, setCpfRepresentanteLegal] = useState('');
  const [naturalidade, setNaturalidade] = useState('');
  const [nacionalidade, setNacionalidade] = useState('');
  const [ufNaturalidade, setUfNaturalidade] = useState('');
  const [sexo, setSexo] = useState('');
  const [estadoCivil, setEstadoCivil] = useState('');
  const [tipoResidencia, setTipoResidencia] = useState('');
  const [tempoResidencia, setTempoResidencia] = useState('');
  const [selectResCob, setSelectResCob] = useState(false);
  const [nomeMae, setNomeMae] = useState('');
  const [nomePai, setNomePai] = useState('');
  const [naturezaOcupacao, setNaturezaOcupacao] = useState('');
  const [empresa, setEmpresa] = useState('');
  const [cargo, setCargo] = useState('');
  const [profissao, setProfissao] = useState('');
  const [cnpj, setCnpj] = useState('');
  const [dtAdmissao, setDtAdmissao] = useState('');
  const [selectComCob, setSelectComCob] = useState(false);
  const [renda, setRenda] = useState('');
  const [outrasRendas, setOutrasRendas] = useState('');
  const [matricula, setMatricula] = useState('');
  const [codigoAutorizacao, setCodigoAutorizacao] = useState('');
  const [mesAnoContraCheque, setMesAnoContraCheque] = useState('');
  const [ref1, setRef1] = useState('');
  const [telefoneRef1, setTelefoneRef1] = useState('');
  const [ref2, setRef2] = useState('');
  const [telefoneRef2, setTelefoneRef2] = useState('');
  const [tipoConta, setTipoConta] = useState('');
  const [banco, setBanco] = useState('');
  const [agencia, setAgencia] = useState('');
  const [conta, setConta] = useState('');
  const [dv, setDv] = useState('');
  const [nomeConjuge, setNomeConjuge] = useState('');
  const [cpfConjuge, setCpfConjuge] = useState('');
  const [rgConjuge, setRgConjuge] = useState('');
  const [dtNascimentoConjuge, setDtNascimentoConjuge] = useState('');
  const [rendaConjuge, setRendaConjuge] = useState('');
  const [telefoneResidencial, setTelefoneResidencial] = useState('');
  const [telefoneCelular, setTelefoneCelular] = useState('');
  const [telefoneComercial, setTelefoneComercial] = useState('');
  const [emails, setEmails] = useState('');

  const [cepResidencia, setCepResidencia] = useState('');
  const [logradouroResidencia, setLogradouroResidencia] = useState('');
  const [numeroResidencia, setNumeroResidencia] = useState('');
  const [complementoResidencia, setComplementoResidencia] = useState('');
  const [bairroResidencia, setBairroResidencia] = useState('');
  const [localidadeResidencia, setLocalidadeResidencia] = useState('');
  const [ufResidencia, setUfResidencia] = useState('');

  const [cepComercial, setCepComercial] = useState('');
  const [logradouroComercial, setLogradouroComercial] = useState('');
  const [numeroComercial, setNumeroComercial] = useState('');
  const [complementoComercial, setComplementoComercial] = useState('');
  const [bairroComercial, setBairroComercial] = useState('');
  const [localidadeComercial, setLocalidadeComercial] = useState('');
  const [ufComercial, setUfComercial] = useState('');
  const [role, setRole] = useState<Role | null>(null);


  const [cepCobranca, setCepCobranca] = useState('');
  const [logradouroCobranca, setLogradouroCobranca] = useState('');
  const [numeroCobranca, setNumeroCobranca] = useState('');
  const [complementoCobranca, setComplementoCobranca] = useState('');
  const [bairroCobranca, setBairroCobranca] = useState('');
  const [localidadeCobranca, setLocalidadeCobranca] = useState('');
  const [ufCobranca, setUfCobranca] = useState('');

  const [loading, setLoading] = useState(false);

  const [showModal, setShowModal] = useState(false);
  const [currentAction, setCurrentAction] = useState<AcaoPropostaEnum | null>(null);
  const [tipoPendenciaRecusa, setTipoPendenciaRecusa] = useState<string>('R');

  const [pixTransferType, setPixTransferType] = useState('nao_tem');
  const [pixKey, setPixKey] = useState('');
  const usuarioService = new UsuarioService();

  const formatarMoeda = (valor: string | number) => {
    if (!valor) return "";
    let v = valor.toString().replace(/\D/g, "");
    v = (Number(v) / 100).toLocaleString("pt-BR", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
    return v;
  };

  const desformatarMoeda = (valor: string) => {
    if (!valor) return 0;
    return parseFloat(valor.replace(/\./g, "").replace(",", "."));
  };

  const handleMoneyChange = (e: React.ChangeEvent<HTMLInputElement>, setter: (v: string) => void) => {
    const { value } = e.target;
    setter(formatarMoeda(value));
  };

  const tiposChavePix = [
    { label: 'Não possui Pix', value: 'nao_tem' },
    { label: 'CPF', value: 'cpf' },
    { label: 'E-mail', value: 'email' },
    { label: 'Telefone Celular', value: 'telefone_celular' },
    { label: 'Chave Aleatória', value: 'aleatoria' },
  ];

  const handleVoltarClick = async () => {
    try {
      setLoading(true);
      await propostaService.liberarAnalise(idProposta);
      navigate(-1);
    } catch (error) {
      console.error("Erro ao liberar a proposta:", error);
      navigate(-1);
    } finally {
      setLoading(false);
    }
  };

  const [propostaEsteira, setPropostaEsteira] = useState<PropostaEsteira[]>([]);

  const clienteService: ClienteService = new ClienteService();
  const viaCepService: ViaCepService = new ViaCepService();
  const propostaEsteiraService: PropostaEsteiraService = new PropostaEsteiraService();
  const bancoService: BancoService = new BancoService();
  const isRgValido = (valorRg: string) => {
    const rgLimpo = valorRg.replace(/[^a-zA-Z0-9]/g, "");
    if (rgLimpo.length < 5 || rgLimpo.length > 14) {
      return false;
    }
    const regexRg = /^[0-9]+[0-9xX]?$/;
    return regexRg.test(rgLimpo);
  };
  const validaEmails = (stringDeEmails: string) => {
    if (!stringDeEmails) return false;
    const lista = stringDeEmails.split(';').map(email => email.trim()).filter(email => email !== "");
    const regexEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    return lista.every(email => regexEmail.test(email));
  };

  const isNomeValido = (nome: string) => {
    const regexNomeCompleto = /^[a-zA-Z\u00C0-\u00FF\s-]{2,}$/;
    return regexNomeCompleto.test(nome.trim());
  };

  const handleNomeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const valorOriginal = e.target.value;
    const valorLimpo = valorOriginal.replace(/[0-9!@#$%&*()_+={}\[\]:;"'<>,.?\/\\|]/g, "");
    setNome(valorLimpo);
  };

  const camposObrigatorios = { nome, rg, dtRg, orgaoRg, ufRg, naturalidade, sexo, estadoCivil, cepResidencia, logradouroResidencia, numeroResidencia, bairroResidencia, localidadeResidencia, ufResidencia, nomeMae, matricula, tipoConta, banco, agencia, conta, dv, telefoneCelular, emails, renda, dtAdmissao, nacionalidade, ufNaturalidade, profissao, cargo };
  const nomesAmigaveis: { [key: string]: string } = {
    nome: "Nome",
    rg: "RG",
    dtRg: "Data de Emissão do RG",
    orgaoRg: "Órgão Emissor do RG",
    ufRg: "UF do RG",
    naturalidade: "Naturalidade",
    nacionalidade: "Nacionalidade",
    ufNaturalidade: "UF Naturalidade",
    sexo: "Sexo",
    estadoCivil: "Estado Civil",
    cepResidencia: "CEP da Residência",
    logradouroResidencia: "Logradouro da Residência",
    numeroResidencia: "Número da Residência",
    bairroResidencia: "Bairro da Residência",
    localidadeResidencia: "Localidade da Residência",
    ufResidencia: "UF da Residência",
    nomeMae: "Nome da Mãe",
    renda: "Renda",
    beneficiario: "Matrícula",
    tipoConta: "Tipo de Conta",
    banco: "Banco",
    agencia: "Agência",
    conta: "Conta",
    dv: "Dígito Verificador",
    telefoneCelular: "Telefone Celular",
    emails: "E-mails",
    dtAdmissao: "Data Admissão",
  };

  const handleModalCancel = () => {
    setShowModal(false);
  };

  const handleModalConfirm = (motivoSelect: string) => {
    if (currentAction) {
      handleSubmit(currentAction, motivoSelect, false);
    }
    setShowModal(false);
  };

  const checkResCob = () => {
    if (cepResidencia !== '' && logradouroResidencia !== '' && numeroResidencia !== '') {
      if (!selectResCob)
        setSelectComCob(false);

      setSelectResCob(!selectResCob);
      setCepCobranca(cepResidencia);
      setLogradouroCobranca(logradouroResidencia);
      setNumeroCobranca(numeroResidencia);
      setComplementoCobranca(complementoResidencia);
      setBairroCobranca(bairroResidencia);
      setLocalidadeCobranca(localidadeResidencia);
      setUfCobranca(ufResidencia);
    }
  };


  const checkComCob = () => {
    if (cepComercial !== '' && logradouroComercial !== '' && numeroComercial !== '') {
      if (!selectComCob)
        setSelectResCob(false);

      setSelectComCob(!selectComCob);
      setCepCobranca(cepComercial);
      setLogradouroCobranca(logradouroComercial);
      setNumeroCobranca(numeroComercial);
      setComplementoCobranca(complementoComercial);
      setBairroCobranca(bairroComercial);
      setLocalidadeCobranca(localidadeComercial);
      setUfCobranca(ufComercial);
    }
  };
  const celularLimpo = (telefoneCelular || "").replace(/\D/g, "");
  const listarCliente = async () => {
    setLoading(true);
    try {
      const responseList = await clienteService.listarClientePorId(idCliente);
      const json = responseList.data.cliente;
      const jsonEnderecos = responseList.data.enderecos;

      setCliente(json);
      setNome(json.nome);
      setIsPEP(json.isPEP);
      setDtNascimento(json.dtNascimento ? format(parseISO(json.dtNascimento), 'dd/MM/yyyy') : '');
      setRg(json.numeroRg);
      setDtRg(json.dtEmissaoRg ? format(parseISO(json.dtEmissaoRg), 'dd/MM/yyyy') : '');
      setOrgaoRg(json.orgaoRg);
      setUfRg(json.ufRg);
      setNomeRepresentanteLegal(json.nomeRepresentanteLegal);
      setCpfRepresentanteLegal(json.cpfRepresentanteLegal);
      setNaturalidade(json.naturalidade);
      setNacionalidade(json.nacionalidade);
      setUfNaturalidade(json.ufNaturalidade);
      setSexo(json.sexo);
      setEstadoCivil(json.estadoCivil);
      setTipoResidencia(json.tipoResidencia);
      setTempoResidencia(json.tempoResidencia);
      setNomePai(json.nomePai);
      setNomeMae(json.nomeMae);
      setNaturezaOcupacao(json.naturezaOcupacao);
      setEmpresa(json.empresa);
      setCargo(json.cargo);
      setProfissao(json.profissao);
      setCnpj(json.cnpjEmpresa);
      setDtAdmissao(json.dtAdmissao ? format(parseISO(json.dtAdmissao), 'dd/MM/yyyy') : '');
      setRenda(json.renda !== null ? formatarMoeda(json.renda.toFixed(2).replace('.', '')) : '');
      setOutrasRendas(json.outrasRendas !== null ? json.outrasRendas.toString() : '');
      setMatricula(json.matricula);
      setCodigoAutorizacao(json.codigoAutorizacao);
      setMesAnoContraCheque(json.mesAnoContraCheque);
      setRef1(json.refNome1);
      setTelefoneRef1(json.refTelefone1);
      setRef2(json.refNome2);
      setTelefoneRef2(json.refTelefone2);
      setTipoConta(json.tipoConta);
      setBanco(json.banco);
      setAgencia(json.agencia);
      setConta(json.conta);
      setDv(json.contaDv);
      setNomeConjuge(json.nomeConjuge);
      setCpfConjuge(json.cpfConjuge);
      setRgConjuge(json.rgConjuge);
      setDtNascimentoConjuge(json.dtNascimentoConjuge ? format(parseISO(json.dtNascimentoConjuge), 'dd/MM/yyyy') : '');
      setRendaConjuge(json.rendaConjuge !== null ? json.rendaConjuge.toString() : '');
      setTelefoneResidencial(json.telefoneResidencial);
      setTelefoneCelular(json.telefoneCelular || '');
      setTelefoneComercial(json.telefoneComercial);
      setEmails(json.email);

      if (jsonEnderecos) {
        jsonEnderecos.forEach((end: ClienteEndereco) => {
          if (end.tipoEndereco === 'Comercial') {
            setCepComercial(end.cep);
            setLogradouroComercial(end.logradouro);
            setNumeroComercial(end.numero);
            setBairroComercial(end.bairro);
            setComplementoComercial(end.complemento);
            setLocalidadeComercial(end.localidade);
            setUfComercial(end.uf);
            setComplementoComercial(end.complemento);
          } else if (end.tipoEndereco === 'Residencial') {
            setCepResidencia(end.cep);
            setLogradouroResidencia(end.logradouro);
            setNumeroResidencia(end.numero);
            setBairroResidencia(end.bairro);
            setLocalidadeResidencia(end.localidade);
            setUfResidencia(end.uf);
            setComplementoResidencia(end.complemento);
          } else if (end.tipoEndereco === 'Cobrança') {
            setCepCobranca(end.cep);
            setLogradouroCobranca(end.logradouro);
            setNumeroCobranca(end.numero);
            setBairroCobranca(end.bairro);
            setLocalidadeCobranca(end.localidade);
            setUfCobranca(end.uf);
            setComplementoCobranca(end.complemento);
          }
        });
      }
      setLoading(false);
    } catch (err: any) {
      if (err.response?.status === 409) {
        console.error("Conflito: Proposta já em análise. Redirecionando para /sem-permissao", err.response.data);

        navigate('/sem-permissao', { state: { message: err.response.data } });

      } else {
        console.error("Erro ao carregar cliente:", err);
        setAlert({ message: err.response?.data || 'Erro ao carregar dados do cliente.', type: 'error' });
        setLoading(false);
      }
    }
  };

  const listarUsuarioPorId = async () => {
    setLoading(true);
    try {
      const id = localStorage.getItem("id") ?? "";
      const response = await usuarioService.listarUsuarioComOrigemPorId(id);
      const json = response.data[0].usuario;

      setRole(json.role);

      setLoading(false);
    } catch (err: any) {
      setLoading(false);
      setAlert({ message: err.response?.data || 'Erro ao carregar usuário', type: 'error' });
      console.error(err);
    }
  };

  const formatDate = (date: String) => {
    const partesData = date.split('/');
    const dataFormatada = partesData[2] + '-' + partesData[1] + '-' + partesData[0];
    return new Date(dataFormatada);
  }

  const verificaBancoDigital = async (banco: string) => {
    const json = await bancoService.verificaBancoDigital(banco);
    let banco1: Banco = new Banco();
    banco1.bancoDigital = json.data.bancoDigital;
    banco1.permiteOperacao = json.data.permiteOperacao;
    console.log(banco1);
    if (banco1.bancoDigital && !banco1.permiteOperacao) {
      return false;
    } else {
      return true;
    }
  }

  const verificaContratosCompraDivida = async (idProposta: any, cpf: any, matricula: any) => {
    const json = await propostaService.verificaContratosCompraDivida(idProposta, cpf, matricula);
    return !!json.data;
  }

  const handleSubmit = async (acaoPropostaEnum: AcaoPropostaEnum, motivoSelect: string | null, isEdicao: boolean, event?: React.FormEvent) => {
    if (event) {
      event.preventDefault();

      const cepsInvalidos = [
        { nome: 'Residência', valor: cepResidencia, obrigatorio: true },
        { nome: 'Comercial', valor: cepComercial, obrigatorio: false },
        { nome: 'Cobrança', valor: cepCobranca, obrigatorio: false },
      ].filter(({ valor, obrigatorio }) => {
        const quantidadeDigitos = valor.replace(/\D/g, '').length;
        return obrigatorio ? quantidadeDigitos !== 8 : valor !== '' && quantidadeDigitos !== 8;
      });

      if (cepsInvalidos.length > 0) {
        setLoading(false);
        return setAlert({
          message: `Informe um CEP válido (8 dígitos) para: ${cepsInvalidos.map(({ nome }) => nome).join(', ')}.`,
          type: 'warning'
        });
      }

      if (!validaEmails(emails)) {
        setLoading(false);
        return setAlert({
          message: 'Um ou mais e-mails informados são inválidos.',
          type: 'warning'
        });
      }

      if (dtRg.length < 10) {
        setLoading(false);
        return setAlert({ message: 'A Data de Emissão do RG está incompleta.', type: 'warning' });
      }

      const dataEmissaoRG = formatDate(dtRg);
      const dataNasc = formatDate(dtNascimento);
      const hoje = new Date();

      hoje.setHours(0, 0, 0, 0);
      if (isNaN(dataEmissaoRG.getTime())) {
        setLoading(false);
        return setAlert({
          message: 'Data de Emissão do RG inválida.',
          type: 'warning'
        });
      }

      if (dataEmissaoRG > hoje) {
        setLoading(false);
        return setAlert({ message: 'A Data de Emissão do RG não pode ser uma data futura.', type: 'warning' });
      }
      if (dataEmissaoRG < dataNasc) {
        setLoading(false);
        return setAlert({ message: 'Emissão anterior à Data de Nascimento.', type: 'warning' });
      }

      if (!isRgValido(rg)) {
        setLoading(false);
        return setAlert({
          message: 'RG inválido. Mínimo 5 dígitos, apenas números e letras.',
          type: 'warning'
        });
      }
      //          if (celularLimpo.length < 11) {
      //   setLoading(false); 
      //   return setAlert({ 
      //     message: 'Telefone Celular inválido', 
      //     type: 'warning' 
      //   });
      // }
      // if (celularLimpo[2] !== '9') {
      //   setLoading(false);
      //   return setAlert({ 
      //     message: 'Formato de celular inválido. O número deve começar com 9 após o DDD.', 
      //     type: 'warning' 
      //   });
      // }

      if (isEdicao) {
        try {
          setLoading(true);
          const response = await propostaEsteiraService.listarPropostaAtividadePorIdProposta(idProposta);
          setLoading(false);
          const situacaoLista: PropostaEsteira[] = response.data.propostaEsteiraList;

          let situacao = situacaoLista[situacaoLista.length - 1].situacaoProposta;


          const usuarioLogado = JSON.parse(localStorage.getItem('usuario') || '{}');
          const isInterno = usuarioLogado.interno === true;
          if ((situacao === 'AND' || situacao === 'INT' || situacao === 'PEN') && role!.tipoAcesso !== 'INTERNO') {
            return setAlert({ message: 'Não é possível alterar cadastro do Cliente: Proposta em Andamento.', type: 'warning' });
          }

        } catch (err: any) {
          setAlert({ message: err.response.data, type: 'error' });
          console.error(err);
        }
      }

      const camposVazios = Object.entries(camposObrigatorios)
        .filter(([_, value]) => !value || value.trim() === "")
        .map(([key]) => `- ${nomesAmigaveis[key] || key}`);

      if (camposVazios.length > 0) {
        return setAlert({
          message: `Os seguintes campos são obrigatórios e precisam ser preenchidos:\n${camposVazios.join("\n")}`,
          type: "warning",
        });
      }
      if (formatDate(dtRg) < formatDate(dtNascimento)) {
        return setAlert({ message: 'Data Emissão RG não pode ser inferior a Data de Nascimento', type: 'warning' });
      }
      if (rg.length < 7 || rg.length > 14) {
        return setAlert({ message: 'RG Inválido, deve ter entre 7 e 14 caracteres', type: 'warning' });
      }
      if (cpfRepresentanteLegal) {
        if (!cpfValidacao.isValid(cpfRepresentanteLegal) || cpfRepresentanteLegal === cliente.cpf) {
          return setAlert({ message: 'CPF Representante Legal Inválido', type: 'warning' });
        }
      }
      if (cpfConjuge) {
        if (!cpfValidacao.isValid(cpfConjuge)) {
          return setAlert({ message: 'CPF Conjuge Inválido', type: 'warning' });
        }
      }
      if (!cnpjValidacao.isValid(cnpj) && cnpj !== '' && cnpj !== null && cnpj !== undefined) {
        return setAlert({ message: 'CNPJ Inválido', type: 'warning' });
      }
      // const contratosCompraDividaDiferentes = await verificaContratosCompraDivida(idProposta, cliente.cpf, matricula);
      // if (!contratosCompraDividaDiferentes) {
      //   erroCompraDivida = true;
      //   acaoPropostaEnum = AcaoPropostaEnum.PENDENCIAR;
      //   motivoSelect = 'Contrato comprado similar encontrado em outra proposta';
      // }
      // const isBancoDigitalAllowed = await verificaBancoDigital(banco);
      // if (!isBancoDigitalAllowed) {
      //   return setAlert({ message: 'Banco digital não autorizado para pagamento de operações', type: 'warning'});
      // }
    }
    try {
      setLoading(true);
      let client: Cliente = new Cliente();
      client.id = parseInt(idCliente!);
      client.cpf = cliente.cpf;
      client.nome = nome;
      client.dtNascimento = cliente.dtNascimento!;
      client.isPEP = isPEP;
      client.numeroRg = rg;
      client.dtEmissaoRg = formatDate(dtRg);
      client.orgaoRg = orgaoRg;
      client.ufRg = ufRg;
      client.nacionalidade = nacionalidade;
      client.naturalidade = naturalidade;
      client.ufNaturalidade = ufNaturalidade;
      client.nomeRepresentanteLegal = nomeRepresentanteLegal;
      client.cpfRepresentanteLegal = cpfRepresentanteLegal;
      client.sexo = sexo;
      client.estadoCivil = estadoCivil;
      client.tipoResidencia = tipoResidencia;
      client.tempoResidencia = tempoResidencia;

      client.nomePai = nomePai;
      client.nomeMae = nomeMae;
      client.naturezaOcupacao = naturezaOcupacao;
      client.empresa = empresa;
      client.profissao = profissao;
      client.cargo = cargo;
      client.cnpjEmpresa = cnpj;
      client.dtAdmissao = formatDate(dtAdmissao);

      client.renda = desformatarMoeda(renda);
      client.outrasRendas = desformatarMoeda(outrasRendas);
      client.rendaConjuge = desformatarMoeda(rendaConjuge);
      client.matricula = matricula;
      client.codigoAutorizacao = codigoAutorizacao;
      client.mesAnoContraCheque = mesAnoContraCheque;
      client.refNome1 = ref1;
      client.refTelefone1 = telefoneRef1;
      client.refNome2 = ref2;
      client.refTelefone2 = telefoneRef2;
      client.tipoConta = tipoConta;
      client.banco = banco;
      client.agencia = agencia;
      client.conta = conta;
      client.contaDv = dv;
      client.nomeConjuge = nomeConjuge;
      client.cpfConjuge = cpfConjuge;
      client.rgConjuge = rgConjuge;
      client.dtNascimentoConjuge = formatDate(dtNascimentoConjuge);

      client.telefoneCelular = telefoneCelular;
      client.telefoneComercial = telefoneComercial;
      client.telefoneResidencial = telefoneResidencial;
      client.email = emails;
      client.chavePix = pixKey;
      client.tipoChavePix = pixTransferType;

      let enderecoRes: ClienteEndereco = new ClienteEndereco();
      enderecoRes.idCliente = parseInt(idCliente!);
      enderecoRes.tipoEndereco = 'Residencial';
      enderecoRes.cep = cepResidencia;
      enderecoRes.logradouro = logradouroResidencia
      enderecoRes.numero = numeroResidencia;
      enderecoRes.complemento = complementoResidencia;
      enderecoRes.bairro = bairroResidencia;
      enderecoRes.localidade = localidadeResidencia;
      enderecoRes.uf = ufResidencia;
      let enderecoCom: ClienteEndereco = new ClienteEndereco();
      enderecoCom.idCliente = parseInt(idCliente!);
      enderecoCom.tipoEndereco = 'Comercial';
      enderecoCom.cep = cepComercial;
      enderecoCom.logradouro = logradouroComercial
      enderecoCom.numero = numeroComercial;
      enderecoCom.complemento = complementoComercial;
      enderecoCom.bairro = bairroComercial;
      enderecoCom.localidade = localidadeComercial;
      enderecoCom.uf = ufComercial;
      let enderecoCob: ClienteEndereco = new ClienteEndereco();
      enderecoCob.idCliente = parseInt(idCliente!);
      enderecoCob.tipoEndereco = 'Cobrança';
      enderecoCob.cep = cepCobranca;
      enderecoCob.logradouro = logradouroCobranca;
      enderecoCob.numero = numeroCobranca;
      enderecoCob.complemento = complementoCobranca;
      enderecoCob.bairro = bairroCobranca;
      enderecoCob.localidade = localidadeCobranca;
      enderecoCob.uf = ufCobranca;

      let enderecos: Array<ClienteEndereco> = [];
      enderecos.push(enderecoRes);
      enderecos.push(enderecoCom);
      enderecos.push(enderecoCob);

      let clienteDTO: ClienteDTO = new ClienteDTO();
      clienteDTO.cliente = client;
      clienteDTO.enderecos = enderecos;
      clienteDTO.propostaEsteira = (edicao === 'proposta' ? true : false);
      clienteDTO.idMotivo = motivoSelect;
      console.log(clienteDTO)

      await clienteService.incluirAlterarCliente(idProposta, acaoPropostaEnum, atualizacaoCadastro, clienteDTO);


      setLoading(false);

      setAlert({ message: 'Alteração realizada com sucesso!', type: 'success' });

      await sleep(2000);
      if (atualizacaoCadastro === 'true')
        window.location.href = '/cliente-consulta/ATUALIZACAO';
      else
        window.location.href = '/esteira-proposta/FLUXO';
    } catch (err: any) {
      setAlert({ message: err.response.data, type: 'error' });
      setLoading(false);
      console.error(err);
    }
  };

  const viaCep = async (cep: string, tipoEndereco: number) => {
    const cepSemMascara = (cep || '').replace(/\D/g, '');
    const cepNormalizado = cepSemMascara.length > 0 && cepSemMascara.length < 8
      ? cepSemMascara.padStart(8, '0')
      : cepSemMascara;

    if (cepNormalizado.length === 8) {
      const cepFormatado = `${cepNormalizado.slice(0, 2)}.${cepNormalizado.slice(2, 5)}-${cepNormalizado.slice(5)}`;
      if (tipoEndereco === 1) setCepResidencia(cepFormatado);
      else if (tipoEndereco === 2) setCepComercial(cepFormatado);
      else if (tipoEndereco === 3) setCepCobranca(cepFormatado);

      setLoading(true);
      try {
        const response = await viaCepService.viaCep(cepNormalizado);

        const jsonViaCep = response.data;
        if (tipoEndereco === 1) {
          setLogradouroResidencia(jsonViaCep.logradouro);
          setLocalidadeResidencia(jsonViaCep.localidade);
          setUfResidencia(jsonViaCep.uf);
          setBairroResidencia(jsonViaCep.bairro);
        } else if (tipoEndereco === 2) {
          setLogradouroComercial(jsonViaCep.logradouro);
          setLocalidadeComercial(jsonViaCep.localidade);
          setUfComercial(jsonViaCep.uf);
          setBairroComercial(jsonViaCep.bairro);
        } else if (tipoEndereco === 3) {
          setLocalidadeCobranca(jsonViaCep.localidade);
          setUfCobranca(jsonViaCep.uf);
          setBairroCobranca(jsonViaCep.bairro);
          setLogradouroCobranca(jsonViaCep.logradouro);
        }
        setLoading(false);
      } catch (err) {
        setLoading(false);
        console.error(err);
      }
    } else {
      if (tipoEndereco === 1) {
        setLogradouroResidencia('');
        setLocalidadeResidencia('');
        setUfResidencia('');
        setBairroResidencia('');
        setNumeroResidencia('');
        setComplementoResidencia('');
      } else if (tipoEndereco === 2) {
        setLogradouroComercial('');
        setLocalidadeComercial('');
        setUfComercial('');
        setBairroComercial('');
        setNumeroComercial('');
        setComplementoComercial('');
      } else if (tipoEndereco === 3) {
        setLocalidadeCobranca('');
        setUfCobranca('');
        setBairroCobranca('');
        setLogradouroCobranca('');
        setNumeroCobranca('');
        setComplementoCobranca('');
      }
    }
  };

  useEffect(() => {
    listarUsuarioPorId();
    listarCliente();
  }, []);

  return (
    <div className="position-relative m-md-3">
      <div style={{ marginBottom: '15px', display: 'flex', justifyContent: 'space-between' }}>
        <h5>Cliente &gt; Alteração</h5>
        <Button
          id="App-button-cor-principal"
          onClick={handleVoltarClick}
        > Voltar
        </Button>
      </div>
      {alert && (<CustomAlert message={alert.message} type={alert.type} onClose={() => setAlert(null)} />)}
      {loading ? <Spinner loading={loading} /> : false}
      <div>
        <div className="card" style={{ marginTop: '25px' }}>
          <div className="card-header">
            <strong>Dados Básicos</strong>
          </div>
          <div className="card-body">
            <div className="row">
              <div className="col-md-1 form-group">
                <label>Código</label>
                <text className="form-control" display={'none'}
                  style={{ color: "Black", backgroundColor: "LightGrey", textAlign: "left" }}>{cliente.id}
                </text>
              </div>
              <div className="col-md-2">
                <label>CPF</label>
                <text className="form-control" display={'none'}
                  style={{ color: "Black", backgroundColor: "LightGrey", textAlign: "left" }}>{cliente.cpf}
                </text>
              </div>

              <div className="col-md-4">
                <label>Nome</label>
                <input
                  id="Campo-obrigatorio"
                  type="text"
                  required
                  className="form-control"
                  value={nome}
                  onChange={handleNomeChange}
                />
              </div>
              <div className="col-md-3">
                <label>Data Nascimento</label>
                <text className="form-control" display={'none'}
                  style={{ color: "Black", backgroundColor: "LightGrey", textAlign: "left" }}> {dtNascimento}
                </text>
              </div>
              <div className="col-md-2">
                <label>É PEP?</label>
                <select className="form-select" value={isPEP ?? 0}
                  onChange={(e) => setIsPEP(Number(e.target.value))}>
                  {situacaoPepEnum.map((item) => (
                    <option key={item.codigo} value={Number(item.codigo)}>
                      {item.descricao}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <fieldset style={{ marginTop: '15px', border: '1px solid #ddd', padding: '20px', marginBottom: '20px', borderRadius: '8px', position: 'relative' }}>
              <legend style={{ fontWeight: 'bold', padding: '0 10px', fontSize: '16px', position: 'absolute', top: '-10px', left: '50%', backgroundColor: '#fff', width: 'auto' }}>
                RG
              </legend>
              <div className="row form-group">
                <div className="col-md-3">
                  <label>Número</label>
                  <InputMask id="Campo-obrigatorio" mask="99999999999999" maskChar={null} type="text" required className="form-control" value={rg} onChange={(e) => setRg((e.target.value).replace(/_/g, ""))} />
                </div>
                <div className="col-md-3">
                  <label>Data Emissão</label>
                  <DateInput
                    required
                    id="Campo-obrigatorio"
                    className="form-control"
                    value={dtRg}
                    onChange={(e) => setDtRg(e.target.value)}
                  />
                </div>
                <div className="col-md-3">
                  <label>Órgão Emissor </label>
                  <input type="text" id="Campo-obrigatorio" required className="form-control"
                    value={orgaoRg} onChange={(e) => setOrgaoRg(e.target.value)}
                  />
                </div>
                <div className="col-md-3">
                  <label>UF Emissão </label>
                  <select required id="Campo-obrigatorio" className="form-select" value={ufRg}
                    onChange={(e) => setUfRg(e.target.value)}>
                    {estadosBrasil.map((item) => (
                      <option key={item.value} value={item.value}>
                        {item.value}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </fieldset>

            <div className="row form-group">
              <div className="col-md-4">
                <label>Nome Representante Legal</label>
                <input type="text" required className="form-control"
                  value={nomeRepresentanteLegal} onChange={(e) => setNomeRepresentanteLegal(e.target.value)}
                />
              </div>
              <div className="col-md-4">
                <label>CPF Representante Legal</label>
                <InputMask mask="999.999.999-99" type="text" className="form-control"
                  value={cpfRepresentanteLegal} onChange={(e) => setCpfRepresentanteLegal((e.target.value).replace(/_/g, ""))}
                />
              </div>
            </div>

            <div className="row form-group" style={{ marginTop: '10px' }}>
              <div className="col-md-2">
                <label>Nacionalidade</label>
                <input type="text" id="Campo-obrigatorio" maxLength={30} required className="form-control"
                  value={nacionalidade} onChange={(e) => setNacionalidade(e.target.value)}
                />
              </div>
              <div className="col-md-2">
                <label>Naturalidade</label>
                <input type="text" id="Campo-obrigatorio" maxLength={30} required className="form-control"
                  value={naturalidade} onChange={(e) => setNaturalidade(e.target.value)}
                />
              </div>
              <div className="col-md-2">
                <label>UF Naturalidade</label>
                <select required id="Campo-obrigatorio" className="form-select" value={ufNaturalidade}
                  onChange={(e) => setUfNaturalidade(e.target.value)}>
                  {estadosBrasil.map((item) => (
                    <option key={item.value} value={item.value}>
                      {item.value}
                    </option>
                  ))}
                </select>
              </div>
              <div className="col-md-2">
                <label>Sexo </label>
                <select required id="Campo-obrigatorio" className="form-select" value={sexo}
                  onChange={(e) => setSexo(e.target.value)}>
                  {sexos.map((item) => (
                    <option key={item.label} value={item.value}>
                      {item.label}
                    </option>
                  ))}
                </select>
              </div>

              <div className="col-md-2">
                <label>Estado Civil</label>
                <select required id="Campo-obrigatorio" className="form-select" value={estadoCivil}
                  onChange={(e) => setEstadoCivil(e.target.value)}>
                  {estadosCivil.map((item) => (
                    <option key={item.label} value={item.value}>
                      {item.label}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="row form-group" style={{ marginTop: '10px' }}>
              <div className="col-md-3">
                <label>Tipo de Residência</label>
                <select className="form-select" value={tipoResidencia}
                  onChange={(e) => setTipoResidencia(e.target.value)}>
                  {tiposResidencia.map((item) => (
                    <option key={item.label} value={item.value}>
                      {item.label}
                    </option>
                  ))}
                </select>
              </div>
              <div className="col-md-3">
                <label>Tempo de Residência</label>
                <select className="form-select" value={tempoResidencia}
                  onChange={(e) => setTempoResidencia(e.target.value)}>
                  {temposResidencia.map((item) => (
                    <option key={item.label} value={item.value}>
                      {item.label}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <hr className="my-4" />

            <div className="row">
              {loading ? <Spinner loading={loading} /> : false}
              <div className="col-md-2">
                <label>CEP </label>
                <InputMask id="Campo-obrigatorio" mask="99.999-999" type="text" className="form-control" required
                  value={cepResidencia}
                  onChange={(e) => setCepResidencia(e.target.value)}
                  onBlur={(e) => viaCep(e.target.value, 1)}
                />
              </div>
              <div className="col-md">
                <label>Endereço</label>
                <input type="text" id="Campo-obrigatorio" className="form-control" required value={logradouroResidencia} onChange={(e) => setLogradouroResidencia(e.target.value)} />
              </div>
              <div className="col-md-3">
                <label>Número</label>
                <input type="number" id="Campo-obrigatorio" maxLength={14} className="form-control" required value={numeroResidencia} onChange={(e) => setNumeroResidencia(e.target.value)} />
              </div>
            </div>

            <div className="row">
              <div className="col-md">
                <label>Bairro </label>
                <input type="text" id="Campo-obrigatorio" className="form-control" required value={bairroResidencia} onChange={(e) => setBairroResidencia(e.target.value)} />
              </div>
              <div className="col-md">
                <label>Complemento</label>
                <input type="text" className="form-control" value={complementoResidencia} onChange={(e) => setComplementoResidencia(e.target.value)} />
              </div>
              <div className="col-md">
                <label>Cidade</label>
                <input type="text" id="Campo-obrigatorio" className="form-control" required value={localidadeResidencia} onChange={(e) => setLocalidadeResidencia(e.target.value)} />
              </div>
              <div className="col-md">
                <label>Estado</label>
                <InputMask mask="aa" id="Campo-obrigatorio" type="text" required className="form-control" value={ufResidencia} onChange={(e) => setUfResidencia(e.target.value.toUpperCase())} />
              </div>
            </div>

            <div className="col-xl">
              <label>
                <input type="checkbox" checked={selectResCob} onChange={checkResCob} />
                Usar o Endereço Residencial para Cobrança
              </label>
            </div>

            <hr className="my-4" />
            <h5>Filiação</h5>

            <div className="row">
              <div className="col-md-5">
                <label className="form-label">Nome Mãe</label>
                <input type="text" required className="form-control" id="Campo-obrigatorio"
                  value={nomeMae} onChange={(e) => setNomeMae(e.target.value)}
                />
              </div>
              <div className="col-md-5">
                <label className="form-label">Nome Pai</label>
                <input type="text" className="form-control"
                  value={nomePai} onChange={(e) => setNomePai(e.target.value)}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="card" style={{ marginTop: '25px' }}>
          <div className="card-header">
            <strong>Comercial</strong>
          </div>
          <div className="card-body">
            <div className="row">
              <div className="col-md">
                <label>Natureza Ocupação</label>
                <select className="form-select" value={naturezaOcupacao}
                  onChange={(e) => setNaturezaOcupacao(e.target.value)}>
                  {naturezaOcupacoes.map((item) => (
                    <option key={item.label} value={item.value}>
                      {item.label}
                    </option>
                  ))}
                </select>
              </div>
              <div className="col-md">
                <label>Empresa</label>
                <input type="text" className="form-control"
                  value={empresa} onChange={(e) => setEmpresa(e.target.value)}
                />
              </div>
              <div className="col-md">
                <label>Profissão</label>
                {isFictor ? <input id="Campo-obrigatorio" required type="text" className="form-control"
                  value={profissao} onChange={(e) => setProfissao(e.target.value)}
                /> : <input type="text" className="form-control"
                  value={profissao} onChange={(e) => setProfissao(e.target.value)}
                />}
              </div>
              <div className="col-md">
                <label>Cargo</label>
                {isFictor ? <input id="Campo-obrigatorio" required type="text" className="form-control"
                  value={cargo} onChange={(e) => setCargo(e.target.value)}
                /> : <input type="text" className="form-control"
                  value={cargo} onChange={(e) => setCargo(e.target.value)}
                />}

              </div>
              <div className="col-md">
                <label>CNPJ (se sócio proprietário)</label>
                <InputMask mask="99.999.999.9999/99" type="text" className="form-control"
                  value={cnpj} onChange={(e) => setCnpj((e.target.value).replace(/_/g, ""))}
                />
              </div>
              <div className="col-md">
                <label>Data Admissão</label>
                <DateInput
                  className="form-control"
                  required
                  id="Campo-obrigatorio"
                  value={dtAdmissao}
                  onChange={(e) => setDtAdmissao(e.target.value)}
                />
              </div>
            </div>

            <div className="row">
              {loading ? <Spinner loading={loading} /> : false}
              <div className="col-md-2">
                <label>CEP</label>
                <InputMask mask="99.999-999" type="text" className="form-control"
                  value={cepComercial}
                  onChange={(e) => setCepComercial(e.target.value)}
                  onBlur={(e) => (viaCep(e.target.value, 2))}
                />
              </div>
              <div className="col-md">
                <label>Endereço</label>
                <input type="text" className="form-control" value={logradouroComercial} onChange={(e) => setLogradouroComercial(e.target.value)} />
              </div>
              <div className="col-md-3">
                <label>Número</label>
                <input type="number" className="form-control" value={numeroComercial} onChange={(e) => setNumeroComercial(e.target.value)} />
              </div>
            </div>

            <div className="row">
              <div className="col-md">
                <label>Bairro</label>
                <input type="text" className="form-control" value={bairroComercial} onChange={(e) => setBairroComercial(e.target.value)} />
              </div>
              <div className="col-md">
                <label>Complemento</label>
                <input type="text" className="form-control" value={complementoComercial} onChange={(e) => setComplementoComercial(e.target.value)} />
              </div>
              <div className="col-md">
                <label>Cidade</label>
                <input type="text" className="form-control" value={localidadeComercial} onChange={(e) => setLocalidadeComercial(e.target.value)} />
              </div>
              <div className="col-md">
                <label>Estado</label>
                <InputMask mask="aa" type="text" className="form-control" value={ufComercial} onChange={(e) => setUfComercial(e.target.value.toUpperCase())} />
              </div>
            </div>

            <div className="col-xl">
              <label>
                <input type="checkbox" checked={selectComCob} onChange={checkComCob} />
                Usar o Endereço Comercial para Cobrança
              </label>
            </div>
          </div>
        </div>

        <div className="card" style={{ marginTop: '25px' }}>
          <div className="card-header">
            <strong>Rendas</strong>
          </div>
          <div className="card-body">
            <div className="row">
              <div className="col-md-2">
                <label>Renda</label>
                <input
                  required
                  className="form-control"
                  id="Campo-obrigatorio"
                  type="text"
                  value={renda}
                  onChange={(e) => handleMoneyChange(e, setRenda)}
                  placeholder="0,00"
                />
              </div>
              <div className="col-md-2">
                <label>Outras Rendas</label>
                <input
                  className="form-control"
                  type="text"
                  value={outrasRendas}
                  onChange={(e) => handleMoneyChange(e, setOutrasRendas)}
                  placeholder="0,00"
                />
              </div>
              <div className="col-md-3">
                <label>Nº Benefício/Matrícula </label>
                <input
                  required
                  type="text"
                  id="Campo-obrigatorio"
                  className="form-control"
                  value={matricula}
                  onChange={(e) => setMatricula(e.target.value.replace(/\D/g, ""))}
                />
              </div>
              <div className="col-md-3">
                <label>Código Autorização</label>
                <input type="text" className="form-control"
                  value={codigoAutorizacao} onChange={(e) => setCodigoAutorizacao(e.target.value)}
                />
              </div>
              <div className="col-md-2">
                <label>Mês/Ano Contra-Cheque</label>
                <InputMask mask="99/9999" className="form-control"
                  value={mesAnoContraCheque} onChange={(e) => setMesAnoContraCheque((e.target.value).replace(/_/g, ""))}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="card" style={{ marginTop: '25px' }}>
          <div className="card-header">
            <strong>Referências Pessoais</strong>
          </div>
          <div className="card-body">
            <div className="row">
              <div className="col-md-4">
                <label>Ref Pessoal 1</label>
                <input type="text" className="form-control"
                  value={ref1} onChange={(e) => setRef1(e.target.value)}
                />
              </div>
              <div className="col-md">
                <label>Telefone Celular</label>
                <InputMask mask="(99)99999-9999" type="text" className="form-control"
                  value={telefoneRef1} onChange={(e) => setTelefoneRef1((e.target.value).replace(/_/g, ""))}
                />
              </div>
              <div className="col-md-4">
                <label>Ref Pessoal 2</label>
                <input type="text" className="form-control"
                  value={ref2} onChange={(e) => setRef2(e.target.value)}
                />
              </div>
              <div className="col-md">
                <label>Telefone Celular</label>
                <InputMask mask="(99)99999-9999" type="text" className="form-control" maskChar={null}
                  value={telefoneRef2} onChange={(e) => setTelefoneRef2((e.target.value).replace(/_/g, ""))}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="card" style={{ marginTop: '25px' }}>
          <div className="card-header">
            <strong>Dados Bancários</strong>
          </div>
          <div className="card-body">
            <div className="row">
              <div className="col-md-2">
                <label>Tipo Conta</label>
                <select
                  required
                  id="Campo-obrigatorio"
                  className="form-select"
                  value={tipoConta}
                  onChange={(e) => setTipoConta(e.target.value)}
                >
                  {tiposConta.map((item) => (
                    <option key={item.label} value={item.value}>
                      {item.label}
                    </option>
                  ))}
                </select>
              </div>

              <div className="col-md-2">
                <label>Banco</label>
                <InputMask
                  id="Campo-obrigatorio"
                  required
                  mask="999"
                  type="text"
                  className="form-control"
                  value={banco}
                  onChange={(e) => setBanco(e.target.value.replace(/_/g, ''))}
                />
              </div>

              <div className="col-md-2">
                <label>Agência</label>
                <InputMask
                  required
                  id="Campo-obrigatorio"
                  mask="99999"
                  type="text"
                  className="form-control"
                  value={agencia}
                  onChange={(e) => setAgencia(e.target.value.replace(/_/g, ''))}
                />
              </div>

              <div className="col-md-2">
                <label>Conta</label>
                <InputMask
                  id="Campo-obrigatorio"
                  required
                  mask="999999999"
                  type="text"
                  className="form-control"
                  maskChar={null}
                  value={conta}
                  onChange={(e) => setConta(e.target.value.replace(/_/g, ''))}
                />
              </div>

              <div className="col-md-2">
                <label>DV</label>
                <InputMask
                  id="Campo-obrigatorio"
                  required
                  mask="9"
                  type="text"
                  className="form-control"
                  value={dv}
                  onChange={(e) => setDv(e.target.value.replace(/_/g, ''))}
                />
              </div>
            </div>
            <div className="row mt-3">
              <div className="col-md-3">
                <label>Tipo de Chave Pix</label>
                <select
                  className="form-select"
                  value={pixTransferType}
                  onChange={(e) => {
                    const value = e.target.value;
                    setPixTransferType(value);

                    if (value === 'nao_tem') {
                      setPixKey('');
                    }
                  }}
                >
                  {tiposChavePix.map((item) => (
                    <option key={item.value} value={item.value}>
                      {item.label}
                    </option>
                  ))}
                </select>
              </div>

              <div className="col-md-5">
                <label>Chave Pix</label>
                <input
                  type="text"
                  className="form-control"
                  value={pixKey}
                  disabled={pixTransferType === 'nao_tem'}
                  required={pixTransferType !== 'nao_tem'}
                  onChange={(e) => setPixKey(e.target.value)}
                  placeholder={
                    pixTransferType === 'cpf'
                      ? 'Informe o CPF'
                      : pixTransferType === 'email'
                        ? 'Informe o e-mail'
                        : pixTransferType === 'telefone_celular'
                          ? 'Informe o telefone'
                          : pixTransferType === 'aleatoria'
                            ? 'Informe a chave aleatória'
                            : ''
                  }
                />
              </div>
            </div>

          </div>
        </div>


        <div className="card" style={{ marginTop: '25px' }}>
          <div className="card-header">
            <strong>Cônjuge</strong>
          </div>
          <div className="card-body">
            <div className="row">
              <div className="col-md-3">
                <label>Nome Cônjuge</label>
                <input type="text" className="form-control"
                  value={nomeConjuge} onChange={(e) => setNomeConjuge(e.target.value)}
                />
              </div>
              <div className="col-md-3">
                <label>CPF Cônjuge</label>
                <InputMask mask="999.999.999-99" type="text" className="form-control"
                  value={cpfConjuge} onChange={(e) => setCpfConjuge((e.target.value).replace(/_/g, ""))}
                />
              </div>
              <div className="col-md-3">
                <label>RG Cônjuge</label>
                <input type="text" className="form-control"
                  value={rgConjuge} onChange={(e) => setRgConjuge(e.target.value)}
                />
              </div>
              <div className="col-md-3">
                <label>Data de Nascimento</label>
                <DateInput
                  className="form-control"
                  value={dtNascimentoConjuge} onChange={(e) => setDtNascimentoConjuge(e.target.value)}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-md-3">
                <label>Renda Cônjuge</label>
                <input
                  type="text"
                  className="form-control"
                  value={rendaConjuge}
                  onChange={(e) => handleMoneyChange(e, setRendaConjuge)}
                  placeholder="0,00"
                />
              </div>
            </div>
          </div>
        </div>

        <div className="card" style={{ marginTop: '25px' }}>
          <div className="card-header">
            <strong>Endereço Cobrança</strong>
          </div>
          <div className="card-body">
            {!selectResCob && !selectComCob ? (
              <>
                <div className="row">
                  {loading ? <Spinner loading={loading} /> : false}
                  <div className="col-md-2">
                    <label>CEP</label>
                    <InputMask mask="99.999-999" type="text" className="form-control"
                      value={cepCobranca}
                      onChange={(e) => setCepCobranca(e.target.value)}
                      onBlur={(e) => viaCep(e.target.value, 3)} />
                  </div>
                  <div className="col-md">
                    <label>Endereço</label>
                    <input type="text" className="form-control" value={logradouroCobranca} onChange={(e) => setLogradouroCobranca(e.target.value)} />
                  </div>
                  <div className="col-md-3">
                    <label>Número</label>
                    <input type="number" className="form-control" value={numeroCobranca} onChange={(e) => setNumeroCobranca(e.target.value)} />
                  </div>
                </div><div className="row">
                  <div className="col-md">
                    <label>Bairro</label>
                    <input type="text" className="form-control" value={bairroCobranca} onChange={(e) => setBairroCobranca(e.target.value)} />
                  </div>
                  <div className="col-md">
                    <label>Complemento</label>
                    <input type="text" className="form-control" value={complementoCobranca} onChange={(e) => setComplementoCobranca(e.target.value)} />
                  </div>
                  <div className="col-md">
                    <label>Cidade</label>
                    <input type="text" className="form-control" value={localidadeCobranca} onChange={(e) => setLocalidadeCobranca(e.target.value)} />
                  </div>
                  <div className="col-md">
                    <label>Estado</label>
                    <InputMask mask="aa" type="text" className="form-control" value={ufCobranca} onChange={(e) => setUfCobranca(e.target.value.toUpperCase())} />
                  </div>
                </div>
              </>

            ) : null}

            {selectResCob && !selectComCob ? (
              <>
                <div className="row">
                  {loading ? <Spinner loading={loading} /> : false}
                  <div className="col-md-2">
                    <label>CEP</label>
                    <text className="form-control" display={'none'}
                      style={{ color: "Black", backgroundColor: "LightGrey", textAlign: "left" }}>{cepResidencia}
                    </text>
                  </div>
                  <div className="col-md">
                    <label>Endereço</label>
                    <text className="form-control" display={'none'}
                      style={{ color: "Black", backgroundColor: "LightGrey", textAlign: "left" }}>{logradouroResidencia}
                    </text>
                  </div>
                  <div className="col-md-3">
                    <label>Número</label>
                    <text className="form-control" display={'none'}
                      style={{ color: "Black", backgroundColor: "LightGrey", textAlign: "left" }}>{numeroResidencia}
                    </text>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md">
                    <label>Bairro</label>
                    <text className="form-control" display={'none'}
                      style={{ color: "Black", backgroundColor: "LightGrey", textAlign: "left" }}>{bairroResidencia}
                    </text>
                  </div>
                  <div className="col-md">
                    <label>Complemento</label>
                    <text className="form-control" display={'none'}
                      style={{ color: "Black", backgroundColor: "LightGrey", textAlign: "left" }}>{complementoResidencia}
                    </text>
                  </div>
                  <div className="col-md">
                    <label>Cidade</label>
                    <text className="form-control" display={'none'}
                      style={{ color: "Black", backgroundColor: "LightGrey", textAlign: "left" }}>{localidadeResidencia}
                    </text>
                  </div>
                  <div className="col-md">
                    <label>Estado</label>
                    <text className="form-control" display={'none'}
                      style={{ color: "Black", backgroundColor: "LightGrey", textAlign: "left" }}>{ufResidencia}
                    </text>
                  </div>
                </div>
              </>
            ) : null}

            {!selectResCob && selectComCob ? (
              <>
                <div className="row">
                  {loading ? <Spinner loading={loading} /> : false}
                  <div className="col-md-2">
                    <label>CEP</label>
                    <text className="form-control" display={'none'}
                      style={{ color: "Black", backgroundColor: "LightGrey", textAlign: "left" }}>{cepComercial}
                    </text>
                  </div>
                  <div className="col-md">
                    <label>Endereço</label>
                    <text className="form-control" display={'none'}
                      style={{ color: "Black", backgroundColor: "LightGrey", textAlign: "left" }}>{logradouroComercial}
                    </text>
                  </div>
                  <div className="col-md-3">
                    <label>Número</label>
                    <text className="form-control" display={'none'}
                      style={{ color: "Black", backgroundColor: "LightGrey", textAlign: "left" }}>{numeroComercial}
                    </text>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md">
                    <label>Bairro</label>
                    <text className="form-control" display={'none'}
                      style={{ color: "Black", backgroundColor: "LightGrey", textAlign: "left" }}>{bairroComercial}
                    </text>
                  </div>
                  <div className="col-md">
                    <label>Complemento</label>
                    <text className="form-control" display={'none'}
                      style={{ color: "Black", backgroundColor: "LightGrey", textAlign: "left" }}>{complementoComercial}
                    </text>
                  </div>
                  <div className="col-md">
                    <label>Cidade</label>
                    <text className="form-control" display={'none'}
                      style={{ color: "Black", backgroundColor: "LightGrey", textAlign: "left" }}>{localidadeComercial}
                    </text>
                  </div>
                  <div className="col-md">
                    <label>Estado</label>
                    <text className="form-control" display={'none'}
                      style={{ color: "Black", backgroundColor: "LightGrey", textAlign: "left" }}>{ufComercial}
                    </text>
                  </div>
                </div>
              </>
            ) : null}
          </div>
        </div>

        <div className="card" style={{ marginTop: '25px' }}>
          <div className="card-header">
            <strong>Contato</strong>
          </div>
          <div className="card-body">
            <div className="row">
              <div className="col-md">
                <label>Telefone Residencial</label>
                <InputMask mask="(99)9999-9999" type="text" className="form-control"
                  value={telefoneResidencial} onChange={(e) => setTelefoneResidencial((e.target.value).replace(/_/g, ""))}
                />
              </div>
              <div className="col-md">
                <label>Telefone Celular</label>
                <InputMask required id="Campo-obrigatorio" mask="(99)99999-9999" type="text" className="form-control"
                  value={telefoneCelular} onChange={(e) => setTelefoneCelular((e.target.value).replace(/_/g, ""))}
                />
              </div>
              <div className="col-md">
                <label>Telefone Comercial</label>
                <InputMask mask="(99)9999-9999" type="text" className="form-control"
                  value={telefoneComercial} onChange={(e) => setTelefoneComercial((e.target.value).replace(/_/g, ""))}
                />
              </div>
            </div>

            <div className="row">
              <div className="col-xl">
                <label>Lista de E-mails (separados por ';')</label>
                <input type="text" required className="form-control" id="Campo-obrigatorio"
                  value={emails} onChange={(e) => setEmails(e.target.value)}
                />
              </div>
            </div>
          </div>
        </div>
        {edicao === 'edicao' ? (
          <div>
            <hr className="my-4" />
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <button className="w-40 btn btn-primary btn-lg btn btn-success" type='submit'
                onClick={(e) => handleSubmit(AcaoPropostaEnum.APROVAR, null, true, e)}>Atualizar Cliente
              </button>
            </div>
          </div>
        ) : (
          <div>
            <hr className="my-4" />
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <button className="w-40 btn btn-primary btn-lg btn btn-success" type='button'
                onClick={(e) => { handleSubmit(AcaoPropostaEnum.APROVAR, null, false, e); }}>Atualizar Cliente e Aprovar
              </button>
              <button
                style={{ backgroundColor: 'RED', color: 'White' }}
                className="btn btn-secondary" type='button'>
                <i className="fa fa-hourglass"
                  onClick={() => {
                    setCurrentAction(AcaoPropostaEnum.REPROVAR);
                    setTipoPendenciaRecusa("R");
                    setShowModal(true);
                  }}
                >
                  Reprovar</i>
              </button>
              <ReprovarOuPendenciarPropostaModal
                showModal={showModal}
                handleModalCancel={handleModalCancel}
                handleModalConfirm={(motivoSelect) => handleModalConfirm(motivoSelect)}
                tipoPendenciaRecusa={tipoPendenciaRecusa}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
export default ClienteComponent;
